import { Grid } from "@mui/material";
import { t } from "i18next";

//import constants
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import images and icons
import Icon from "../../../common/base-icon/icon";
import { User } from "iconsax-react";

function PassengerList({ passengerItem, handleSelectedPassenger }) {
    //passenger details

    return (
        <Grid
            className="passenger__passenger-item"
            container
            item
            xs={12}
            justifyContent="space-between"
            onClick={() => handleSelectedPassenger(passengerItem, true)}
        >
            <Grid container item xs={8} columnGap={1} alignItems="center">
                {passengerItem?.gender?.id === 1 ? (
                    <User size={IS_MOBILE ? "16" : "24"} color="var(--teal-color-18)" variant="Bold" />
                ) : passengerItem?.gender?.id === 2 ? (
                    <Icon name="genderIcon" width="1rem" />
                ) : (
                    "-"
                )}
                <Grid container item xs="auto" direction="column">
                    <span className="passenger__label">{`${passengerItem?.first_name || " "} ${passengerItem?.last_name || " "}`}</span>
                    <span className="passenger__label">
                        {passengerItem?.english_first_name} {passengerItem?.english_last_name}
                    </span>
                </Grid>
            </Grid>
            <Grid container item xs={3.5} direction="column">
                <span className="passenger__label">{t("nationalCode")}</span>
                <span className="passenger__label">{passengerItem?.national_code}</span>
            </Grid>
        </Grid>
    );
}

export default PassengerList;
